import React, {useState} from "react";
import TableFunction from "../../../../components/table/TableFunction";
import CustomTh from "../../../../components/table/CustomTh";
import CustomTd from "../../../../components/table/CustomTd";
import CustomImageTable from "../../../../components/CustomImageTable";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import {
    DeleteIconsOptions, UpdateIconsOptions, DetailsIconsOptions, IconAreaTable, IconPlusFill
} from "../../../../components/buttons/IconButtons";
import ListDisplayWithTooltip from "../../../../components/ListDisplayWithTooltip";
import BoyAvatar from "../../../../assets/images/boyAvatarT.svg";
import womanAvatar from "../../../../assets/images/womanAvatarT.png";
import {EMPTY_VALUES} from "../../../../Apis/functions";
import {useDispatch} from "react-redux";
import {SearchByFilters, SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {CRITERIA_MODEL, SEARCH_MODEL} from "../../../../components/table/Model/TableModel";

/**
 * Table view of the roster of the guards.
 */
const GuardRosterTableApp = (props) => {
    const {
        selectedList,
        setSelectedList,
        modified,
        setModified,
        setDeleteModal,
        setIsAllChecked,
        searchElement,
        setBodyForExport,
        setCriteria,
        finalArray,
        option,
        view,
        goUpdate,
        canUpdate,
        canDelete,
    } = props;

    const [results, setResults] = useState(null);
    const tableId = 'tbl_gr_guards';
    const searchId = 'txt_gr_search_guards';

    const dispatch = useDispatch();

    // The rows are selected by the employee record of the guard, the one it is deleted with
    const setSearchResults = (data) => setResults(data ? {
        ...data,
        content: (data?.content || []).map((item) => ({...item, id: item.employeeId})),
    } : data);

    const getData = (page, {rowsPerPage}) => {
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, model: option, key: searchElement, view});
        setBodyForExport(body);
        dispatch(SimpleSearch({body})).then(({payload: {data: {data, success}}}) => {
            if (success) setSearchResults(data);
        });
    };

    // The body is kept as the criteria, the header exports the advanced search with it
    const getDataAdvancedSearch = (page, {rowsPerPage}) => {
        const criteria = finalArray.map((item) => CRITERIA_MODEL.set(item));
        const body = SEARCH_MODEL.setObject({page, size: rowsPerPage, criteria, view});
        setCriteria(body);
        dispatch(SearchByFilters({option, body})).then(({payload: {data: {data, success}}}) => {
            if (success) setSearchResults(data);
        });
    };

    const getThead = () => [
        <CustomTh tableId={tableId} fixedXY={true} left={canDelete ? 50 : 0} classes='first_head'>{t('name')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('email')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('phone_number')}</CustomTh>,
        <CustomTh tableId={tableId}>{t('zone_access')}</CustomTh>,
    ];

    const getTbody = () => {
        if (!results?.content?.length) return {body: [], data: []};

        const body = results.content.map((item, index) => (
            <>
                <CustomTd tableId={tableId} tooltip={item?.fullName} fixed={true} left={canDelete ? 50 : 0} classes={'first-column'}>
                    <span className='text-ellipsis'>
                        <CustomImageTable
                            text={item?.fullName}
                            image={item?.genderId === 2 ? womanAvatar : BoyAvatar}
                            classNameImage={'object-fit-contain'}
                            buttonImg={'btn_gr_expand_image_' + index}
                        />
                    </span>
                </CustomTd>
                <CustomTd tableId={tableId}>{item?.email || EMPTY_VALUES.DEFAULT}</CustomTd>
                <CustomTd tableId={tableId}>{item?.phoneNumber || EMPTY_VALUES.DEFAULT}</CustomTd>
                <CustomTd tableId={tableId} classes={"py-3"}>
                    {/* The zone accesses come joined by commas, each one is shown on its own line */}
                    <ListDisplayWithTooltip
                        items={(item?.zoneAccessName || '').split(',').map((name) => name.trim()).filter(Boolean)}
                        renderItem={(name) => name}
                        maxInline={2}
                        emptyValue={EMPTY_VALUES.DEFAULT}
                        icon={<IconPlusFill width={20} height={20}/>}
                        itemIcon={<IconAreaTable width={20} height={20} className="icon-color-general-950"/>}
                    />
                </CustomTd>
            </>
        ));
        return {body, data: results.content};
    };

    const getActionsButtons = (item, index) => (
        <DropDownMenuProfile
            openMenu={openMenu}
            handleMenuToggle={handleMenuToggle}
            menuId={`menu-${item.id}`}
        >
            {/* Without the update permission the guard is opened read-only, as its details */}
            <DropDownMenuItem
                id={`btn_gr_${canUpdate ? 'update' : 'details'}_${index}`}
                index={index}
                handleClose={handleClose}
                name={t(canUpdate ? 'update' : 'details')}
                icon={canUpdate ? <UpdateIconsOptions/> : <DetailsIconsOptions/>}
                click={() => goUpdate(item)}
            />
            {canDelete &&
                <DropDownMenuItem
                    id={`btn_gr_delete_${index}`}
                    index={index}
                    handleClose={handleClose}
                    name={t('delete')}
                    icon={<DeleteIconsOptions/>}
                    fontColor={'font-color-error-600'}
                    iconColor={'icon-color-error-code-600'}
                    click={() => {
                        setSelectedList([item?.id]);
                        setDeleteModal(true);
                    }}
                />
            }
        </DropDownMenuProfile>
    );

    const {
        t, thead, tbody, handleCheckboxChange, handleDeleteAll, pagination, rowsPerPage,
        openMenu, handleMenuToggle, handleClose
    } = TableFunction({
        selectedList,
        setSelectedList,
        data: results,
        view,
        getThead,
        getTbody,
        labelRowsPerPage: 'guards_per_page',
        hasContainer: true,
        fixedPagination: false,
        setIsAllChecked,
        searchElement,
        getData,
        modified,
        setModified,
        getDataAdvancedSearch,
        finalArray,
    });

    return {
        t,
        tableId,
        searchId,
        setSearchResults,
        rowsPerPage,
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        getActionsButtons,
    };
};

export default GuardRosterTableApp;
